module.exports = __webpack_public_path__ + "static/004_001-e9d4b6d157006b3d27f35c062fe8ac96.jpg";